/* eslint-disable */

/*
Ajaxを使わない
検索画面用
*/

//画面表示時の検索フォームの状態を保持
var serializedForm = null;

$(document).ready(function()
    {

	

	//ソートリンクを押したとき
	$(".selectSort").click(function () {
		var sort_item=$(this).attr("id"); 
		//変更前のソート条件を取得
		var before_sort_item=$("#srt").val();
		var before_sort_order=$("#srt_ad").val();

		setSearchForm();

		$("#srt_ad").val("asc");
		//同じソートアイテムを選ばれたときにはDESCとASCを反転
		if(sort_item == before_sort_item && before_sort_order == "asc") {
			$("#srt_ad").val("desc");
		}
	
		$("#srt").val(sort_item);
		$("#pg").val(1);

		document.searchForm.target="_self";

		if($("#searchForm").data("action") == null) {

			document.searchForm.action =location.pathname;
		} else {
			document.searchForm.action = $("#searchForm").data("action");
		}
		document.searchForm.submit();
	});


	//検索ボタンを押したとき
	$(".searchButton").click(function () {
		$("#pg").val(1);
		try {
			if(!searchValidate()) {
				return false;
			}
		}catch(e){}
		document.searchForm.target="_self";

		if($("#searchForm").data("action") == null) {
			document.searchForm.action =location.pathname;
		} else {
			document.searchForm.action = $("#searchForm").data("action");
		}
		document.searchForm.submit();
	});

	//ソートマーク（やじるし）をつける
	var sort_item=$("#srt").val();
	if(sort_item != null && "" != sort_item){
		if($("#srt_ad").val() == "asc") {
			$("#"+sort_item).after(' <i class="fa fa-arrow-down"></i>');
		} else {
			$("#"+sort_item).after(' <i class="fa fa-arrow-up"></i>');
		}
	}

    serializedForm = $("#searchForm").serialize();
});


/**
 * 検索フォームの内容を画面表示時の状態にする
 * CSVダウンロード、ページング時、並び替え時に使用
 */
function setSearchForm() {

	//SearchForm内のチェックボックスをすべて外す
	var obj= new Object();
	$("#searchForm input:checkbox").each(function(){
		$(this).prop("checked",false);
	});
	//クエリ文字列を設定
    var vars = [], max = 0, hash = "", array = "";
    //複数のクエリ文字列に対応するため、&で区切る
    hash  = serializedForm.slice(0).split('&');    
    max = hash.length;

    for (var i = 0; i < max; i++) {
        array = hash[i].split('=');    //keyと値に分割。
		if(($('#'+array[0]).length || $('#'+array[0]+array[1]).length) 
			&& !(array[0] == 'dsp' || array[0] == 'tree_name' || array[0] == 'is_dragable' ||  array[0] == 'select_tag_id' || array[0] == 'tag_hide_flg')){    //key値の要素が存在すれば値をセット
			try {
				//serialize()によって、スペースが+に置換されてしまうのでそれをまたスペースに置換
				array[1]=decodeURIComponent(array[1].replace(/\+/g, '%20'));
			} catch(e) {}
;
			//checkbox
			if($('#'+array[0]).is(':checkbox')) {
				$('#'+array[0]).prop("checked",true);
				//console.log('#'+array[0]+ ":checked");

			//radio
			}else if($("input[name="+array[0]+"]").is('input:radio')) {
				$('#'+array[0]+array[1]).val([array[1]]); //radio
				//console.log('#'+array[0]+ ":radio checked");

			//others
			} else {
				$('#'+array[0]).val(array[1]);
				//console.log('#'+array[0]+ ":"+array[1]);
			}
		}
    }

	//各ページ内で定義されているリセット関数を呼ぶ
	try {
		if(!resetForm()) {
			return false;
		}
	}catch(e){}


}

//CSVボタンを押したとき
function csv_download(act_nm){
	setSearchForm();
	document.searchForm.target="_blank"
	document.searchForm.action = act_nm;
	document.searchForm.submit();
}
//ページングリンクを押したとき
function selectPage(page_num) {
	setSearchForm();
	$("#pg").val(page_num);
	document.searchForm.target="_self"
	document.searchForm.action = $("#searchForm").data("action");
	document.searchForm.submit();
}


window.setSearchForm = setSearchForm;
window.csv_download = csv_download;
window.selectPage = selectPage;


// WEBPACK FOOTER //
// ./es6/admin-common-js/legacy/searchlist.js